import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
import Vant from 'vant'
import 'vant/lib/index.css'
import './utils/filter'
import clipboardDirective from './utils/clipboard'

const style = document.createElement('style')
style.innerHTML = `
  .ant-message {
    z-index: 9999 !important;
  }
`
document.head.appendChild(style)

Vue.config.productionTip = false
Vue.use(Antd)
Vue.use(Vant)
Vue.directive('clipboard', clipboardDirective)

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
